module.exports = __webpack_public_path__ + "static/media/DQ-Learning.c8a7ae65.png";